import React from 'react';

import { InstallableAppCardList } from 'client/blocks/AppCardList/InstallableAppCardList';
import { SkillsCardList } from 'client/blocks/AppCardList/SkillsCardList';
import { IndexLayout } from 'client/blocks/Layout/Layout';
import { WithAppsMetaInfo, withAppsMetaInfo } from 'client/context/appsMetaInfoContext';
import { Channel } from 'client/model/skill';
import { getIsYangoRequest, isInstallableAppChannel } from 'client/utils';

import styles from './AppsIndex.module.scss';
import { AppsIndexNavbar } from './AppsIndexNavbar';

interface InstallableAppsIndexProps {
    channel: Channel;
}

const AppsIndex = ({ channel }: InstallableAppsIndexProps & WithAppsMetaInfo) => {
    return (
        <IndexLayout>
            <article className={styles.appsIndex__container}>
                <AppsIndexNavbar channel={channel} />
                {isInstallableAppChannel(channel) && !getIsYangoRequest() ? (
                    <InstallableAppCardList channel={channel} />
                ) : (
                    <SkillsCardList channel={channel} />
                )}
            </article>
        </IndexLayout>
    );
};

export default withAppsMetaInfo(AppsIndex);
